import { get } from './api';
import { ClaimStatusI } from 'declarations/interfaces/claimStatuses';

export const getClaimStatusesApi = async (roofTopId: string | undefined) => {
  const response = await get<ClaimStatusI[]>('/tickets/claim-statuses', { roofTopId });
  return response.data;
};
